import React, { Component } from "react";
import { List, Collapse, Card } from "antd";
import { WhiteSpace } from "peak-design";
import styles from "./styles/clinicalTrialItem.module.scss";

const Panel = Collapse.Panel;

class ClinicalTrialItem extends Component {
  renderConditions = () => {
    const { condition } = this.props.trial.conditions;
    const pattern = ", ";
    const conditionString = convertIfArrayAndStringify(condition, pattern);
    return (
      <div>
        <strong>Condition(s): </strong>
        {conditionString}
      </div>
    );
  };
  renderLocations = () => {
    const { location } = this.props.trial.locations;
    const pattern = " | ";
    const locationString = convertIfArrayAndStringify(location, pattern);
    return <div>{locationString}</div>;
  };
  renderAgeRange = () => {
    const { min_age, max_age } = this.props.trial;
    let ageRange = "";
    if (min_age && !max_age) ageRange = `${min_age} +`;
    else if (!min_age && max_age) ageRange = `up to ${max_age}`;
    else if (!min_age && !max_age) ageRange = "None";
    else ageRange = `${min_age} - ${max_age}`;
    return (
      <div>
        <strong>Age Range: </strong>
        {ageRange}
      </div>
    );
  };
  renderPhases = () => {
    const { phase } = this.props.trial.phases;
    const pattern = ", ";
    const phaseString = convertIfArrayAndStringify(phase, pattern);

    return (
      <div>
        <strong>Phase(s): </strong>
        {phaseString}
      </div>
    );
  };
  renderItemDescription = () => {
    const { trial } = this.props;
    let interventions;
    if (trial.interventions.intervention) {
      trial.interventions.intervention.$
        ? (interventions = `${trial.interventions.intervention.$.type} -- ${
            trial.interventions.intervention._
          }`)
        : (interventions = "None");
    }

    return (
      <div>
        <a className={styles.itemTitle} href={trial.url}>
          {trial.title}
        </a>
        <WhiteSpace height={10} />
        {this.renderLocations()}
        <Collapse bordered={false}>
          <Panel
            header="More details"
            key={trial.url}
            className={styles.collapseItem}
          >
            {this.renderConditions()}

            {this.renderAgeRange()}
            <div>
              <strong>Gender: </strong>
              {trial.gender}
            </div>
            <div>
              <strong>Start Date: </strong>
              {trial.start_date}
            </div>
            <div>
              <strong>Status: </strong>
              {trial.status._}
            </div>
            <div>
              <strong>Results: </strong>
              {trial.study_results}
            </div>
            <div>
              <strong>Interventions: </strong>
              {interventions}
            </div>
            {this.renderPhases()}
            <div>
              <strong>Study Type: </strong>
              {trial.study_types}
            </div>
            <div>
              <strong>Lead Sponsor: </strong>
              {trial.sponsors.lead_sponsor}
            </div>
          </Panel>
        </Collapse>
      </div>
    );
  };
  render() {
    return (
      <List.Item className={styles.trialItem}>
        <Card className={styles.card}>{this.renderItemDescription()}</Card>
      </List.Item>
    );
  }
}

function convertIfArrayAndStringify(data, pattern) {
  let string = "";
  let ect = false;
  if (data && data instanceof Array) {
    data.forEach((item, index) => {
      if (index < 5) {
        index + 1 === data.length
          ? (string += `${item}`)
          : (string += `${item}${pattern}`);
      } else if (index >= 5 && ect === false) {
        string += " and many more...";
        ect = true;
      }
    });
  } else {
    string = data;
  }
  return string;
}

export { ClinicalTrialItem };



// WEBPACK FOOTER //
// ./src/components/items/ClinicalTrialItem.js